/*
 * @Author: libo 
 * @Date: 2020-11-18 21:11:26 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-06 19:51:33
 */

<!--换表界面-->
<template>
  <a-spin :spinning="confirmLoading">
    <div>
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" header="用户信息">
          <detail-list>
            <detail-list-item term="用户编号">{{model.userId}}</detail-list-item>
            <detail-list-item term="用户姓名">{{model.userName}}</detail-list-item>
            <detail-list-item term="手机号码">{{model.userPhone}}</detail-list-item>
            <detail-list-item term="身份证号">{{model.userIdNumber}}</detail-list-item>
            <!-- <detail-list-item term="户型ID">{{model.userHouseholdCode}}</detail-list-item> -->
            <!-- <detail-list-item term="类型编码">{{model.userTypeCode}}</detail-list-item> -->
            <detail-list-item term="价格编码">{{model.userPriceCode}}</detail-list-item>
            <detail-list-item term="价格名称">{{model.wtName}}</detail-list-item>
            <detail-list-item term="价格总计">{{model.wtTotalPrice}}</detail-list-item>
            <detail-list-item term="用水状态">{{model.userState}}</detail-list-item>
            <detail-list-item term="区域名称">{{model.userAreaName}}</detail-list-item>
            <!-- <detail-list-item term="营收编号">{{model.userPayId}}</detail-list-item> -->
            <!-- <detail-list-item term="类型">{{model.userIdType==1?"自然人":model.userIdType==0?"企业":""}}</detail-list-item> -->
            <!-- <detail-list-item term="优惠信息">{{model.userFreeinfo==1?"按户":model.userFreeinfo==2?"按人":model.userFreeinfo==3?"按月":model.userFreeinfo==4?"按量":""}}</detail-list-item> -->
            <!-- <detail-list-item term="是否允许缴费">{{model.userPayState}}</detail-list-item> -->
            <!-- <detail-list-item term="用水地址">{{model.userMeterAddr}}</detail-list-item> -->
            <!-- <detail-list-item term="小区名或村庄名">{{model.userCommName}}</detail-list-item> -->
            <!-- <detail-list-item term="备注">{{model.remark}}</detail-list-item> -->
          </detail-list> 
        </a-collapse-panel>
        <a-collapse-panel key="2" header="表具信息">
          <detail-list title="旧表具信息">
            <detail-list-item term="表编号">{{model.meterId}}</detail-list-item>
            <detail-list-item term="安装经度">{{model.userMeterLng}}</detail-list-item>
            <detail-list-item term="安装维度">{{model.userMeterLat}}</detail-list-item>
            <detail-list-item term="阀门状态">{{model.userValveOpenorclose==0?"无动作":model.userValveOpenorclose==1?"开阀":model.userValveOpenorclose==2?"关阀":''}}</detail-list-item>
            <detail-list-item term="起始读数">{{model.userMeterStartNum}}</detail-list-item>
            <detail-list-item term="计费读数">{{model.userMeterOpenNum}}</detail-list-item>
            <detail-list-item term="表安装地址">{{model.userAddr}}</detail-list-item>
          </detail-list><a-divider />
          <div>
          <a-form :form="form" slot="detail" :colon="false">
          <detail-list title="新表具信息">
            <a-row :gutter="16">
            <a-col :span="8">
              <a-form-item label="表编号">
                <a-input  v-decorator="['meterIdNew',validatorRules.meterId]" placeholder="请输入表编号" type="number" style="width:100%"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="表计费起始读数">
                <a-input-number v-decorator="['meterStartNum',validatorRules.userMeterStartNum]" placeholder="请输入用户表计费起始读数" style="width:100%"></a-input-number>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="换表原因类型">
                <a-select v-decorator="['meterChangeType']" placeholder="请输入换表原因类型" style="width:100%">
                  <a-select-option :value="1">
                    流量异常
                  </a-select-option>
                  <a-select-option :value="2">
                    机械故障
                  </a-select-option>
                  <a-select-option :value="3">
                    其他
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-form-item label="换表原因描述" >
              <a-textarea v-decorator="['meterChangeReason']" placeholder="请输入换表原因描述" :rows="3"></a-textarea>
            </a-form-item>
          </a-row>
          </detail-list>
          </a-form>
          </div> 
        </a-collapse-panel>
      </a-collapse>
    </div>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { listSize } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import { duplicateCheck } from '@/api/api'
  import PageLayout from '@/components/page/PageLayout'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  const genreList = [
    {key: 1, title: '流量异常'},
    {key: 2, title: '机械故障'},
    {key: 3, title: '其他'},
  ]
  export default {
    name: 'MeterTableOfStringsForm',
    components: {
      JFormContainer,
      PageLayout,
      DetailList,
      DetailListItem
    },
    data () {
      return {
        activeKey:[1,2],
        form: this.$form.createForm(this),
        model: {},
        confirmLoading: false,
        validatorRules: {
          meterId:{   //表编号
            rules:[
              {required: true,validator: this.validatePlanName}, 
            ]
          },
          userMeterStartNum:{  //表计费起始读数
            rules:[
              {required:true,message:'请输入表计费起始读数！'},
            ]
          },
        },
        userHouseholdCodeList:[], // 用户户型
        userTypeList:[], //  类型编码
        userPriceCode:[], // 价格编码
        genreList,
        meterChangeType:'',
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meteChangeMeterRecord/doChangeMeterTask",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          userHouseholdCodeList: "/jeecg-charge/meter/meterHousehold/list",
          userTypeList:"/jeecg-charge/meter/meterUserType/list",
          userPriceCode:"/jeecg-charge/meter/meterPriceinfo/list",
        },
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      },
      title () {
        return this.$route.meta.title
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        console.log(this.model);
        this.visible = true;
        this.queryUserHouseholdCodeList();
        this.queryUserTypeList();
        this.queryUserPriceCode();
      },
      // 查询表编号名称是否重复
      validatePlanName(rule, value, callback){
        if (value==undefined || value=='')  {
           callback('请输入表编号!')
        }else{
          var params ={
          tableName:'meterinfo',
          fieldName:'meter_id',
          fieldVal:value,
          dataId:this.model.id
          };
          duplicateCheck(params).then((res) => {
            console.log(res);
          if (res.success) {
            callback("请在表具信息页面中添加该表编号！")
          } else {
            callback()
          }
        })
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign({}, values);
            formData.meterIdOld = this.model.meterId
            formData.userId = this.model.userId
            formData.userKeyId = this.model.id
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      queryUserHouseholdCodeList() {  //用户户型
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userHouseholdCodeList, params).then((res) => {
          if(res.success){
           this.userHouseholdCodeList = res.result.records;
          }
        })
      },
      queryUserTypeList() {  //类型编码
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
           this.userTypeList = res.result.records;
          }
        })
      },
      queryUserPriceCode() {  //价格编码
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.userPriceCode = res.result.records;
            console.log(this.userPriceCode);
          }
        })
      },
    }
  }
</script>

<style scoped>
.ant-form-item >>> .ant-form-item-label{
  line-height: 40px;
}
.ant-form-item >>> .ant-select{
  width: 100%;
}
.detail-list >>> .content{
    line-height: normal;
}
</style>